import * as React from "react";

export class Row extends React.Component<{}, {}> {
    render() {
        return (
            <div className="rj-racing-current-races__row">{this.props.children}</div>
        )
    }
}